// Components
import Ranking from '../Ranking'
import Button from '../../../../components/Button'

// Utilities
import { useState, useEffect, useCallback } from 'react'
import { getDowString } from 'utils'
import { getDateString } from 'utils'
import { getHourString } from 'utils'
import { settings } from '../../../../settings'
import Spinner from 'components/Spinner'

const MINUTES_BEFORE_START = 2
const days = 1000 * 60 * 60 * 24
const hours = 1000 * 60 * 60
const minutes = 1000 * 60
const seconds = 1000

export default function CustomSubject({
  nextSubjectDate,
  participated,
  rankingData,
  currentUser,
  startNewSubject,
  subjectID,
}) {
  const [remainingTime, setRemainingTime] = useState(null)

  const updateTime = useCallback(() => {
    if (nextSubjectDate === null) {
      return
    }

    const currentDate = new Date()
    let timeDifference = new Date(nextSubjectDate['start'] * 1000) - currentDate

    if (timeDifference < 0) {
      timeDifference = new Date(nextSubjectDate['end'] * 1000) - currentDate
    }

    setRemainingTime(timeDifference)
  }, [setRemainingTime, nextSubjectDate])

  const getTimeRemaining = useCallback(() => {
    return {
      days: Math.floor(remainingTime / days),
      hours: Math.floor((remainingTime % days) / hours),
      minutes: Math.floor((remainingTime % hours) / minutes),
      seconds: Math.floor((remainingTime % minutes) / seconds),
    }
  }, [remainingTime])

  useEffect(() => {
    if (nextSubjectDate === null) {
      return
    }
    updateTime()
    const timer = setInterval(updateTime, 1000)
    return () => clearInterval(timer)
  }, [nextSubjectDate, updateTime])

  const nextSubjectDateString = useCallback(() => {
    if (nextSubjectDate === null) {
      return 'Loading...'
    }

    const date = new Date(nextSubjectDate['start'] * 1000)
    const now = new Date()

    const simulareDay = new Date(date)

    let dayString
    // Check if date is today
    if (simulareDay.setHours(0, 0, 0, 0) === now.setHours(0, 0, 0, 0)) {
      dayString = 'astăzi'
    } else {
      dayString = `${getDowString(date).toLowerCase()}, ${getDateString(date)}`
    }

    return `${dayString}, la ora ${getHourString(date)}`
  }, [nextSubjectDate])

  function startSubject() {
    if (subjectID) {
      startNewSubject(subjectID)
    }
  }

  const getTimeRemainingString = () => {
    let ret = ''

    const time = getTimeRemaining()

    if (remainingTime > days)
      ret += `${time.days} ${time.days === 1 ? 'zi' : 'zile'} : `
    if (remainingTime > hours && time.hours > 0)
      ret += `${time.hours} ${time.hours === 1 ? 'oră' : 'ore'} : `
    if (remainingTime > minutes && time.minutes > 0)
      ret += `${time.minutes} ${time.minutes === 1 ? 'minut' : 'minute'} : `

    ret += time.seconds + (time.seconds === 1 ? ' secundă' : ' secunde')

    return ret
  }

  const simulareStarted = () => {
    if (nextSubjectDate === null) {
      return false
    }

    const started = new Date(nextSubjectDate['start'] * 1000) < new Date()
    return started
  }

  return (
    <div className="w-full h-full flex flex-col items-center">
      {nextSubjectDate === null ? (
        <Spinner />
      ) : nextSubjectDate['start'] ? (
        <>
          <div className="py-6 flex flex-col items-center">
            <p className="text-over-primary-background text-center">
              {!simulareStarted() ? (
                <span>
                  Următoarea simulare este {nextSubjectDateString()} și durează
                  2 ore
                </span>
              ) : (
                <span>
                  {participated > 0
                    ? 'Ai terminat simularea. Așteaptă până la final pentru a vedea clasamentul!'
                    : 'Simularea a început deja!'}
                </span>
              )}
            </p>
            <p className="text-sm text-over-primary-background text-center">
              {getTimeRemainingString()}
            </p>
          </div>
          {(simulareStarted() ||
            remainingTime < MINUTES_BEFORE_START * minutes) && (
            <Button
              disabled={
                participated > 0 ||
                (!simulareStarted() && (remainingTime > 0 || !subjectID))
              }
              className="bg-primary py-2"
              onClick={startSubject}
            >
              Participă
            </Button>
          )}
          {rankingData &&
            !simulareStarted() &&
            remainingTime >= MINUTES_BEFORE_START * minutes && (
              <Ranking rankingData={rankingData} currentUser={currentUser} />
            )}
        </>
      ) : (
        <>
          <div className="py-6 flex flex-col items-center">
            <p className="text-over-primary-background text-center">
              Momentan nu există nici o simulare programată
            </p>
            {settings.community_url ? (
              <>
                <p className="text-over-primary-background text-sm text-center">
                  Intră și tu în comunitatea noastră de Whatsapp si află când
                  apare noua simulare!
                </p>
                <a
                  href={settings.community_url}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Button className="bg-primary py-2 mt-4">
                    Comunitate whatsapp
                  </Button>
                </a>
              </>
            ) : null}
          </div>
          {rankingData && (
            <Ranking rankingData={rankingData} currentUser={currentUser} />
          )}
        </>
      )}
    </div>
  )
}
